import { AccessToCoursesEnum } from 'enum/accessToCourses'
import { AccessToLearningProgramsEnum } from 'enum/accessToLearningPrograms'
import { IRoleDetail } from 'interfaces/roles'

export const initialRoleDetail: IRoleDetail = {
  name: '',
  code: '',
  description: '',
  isDefault: false,
  learningPrograms: [],
  accessToLearningPrograms: AccessToLearningProgramsEnum.None,
  courses: [],
  accessToCourses: AccessToCoursesEnum.None,
  accesses: {
    manageInternalCourses: false,
    manageExternalCourses: false,
    manageLearningPrograms: false,
    viewCourseInformation: false,
    downloadReport: false,
    manageParticipants: false,
    manageProgress: false,
    manageAdministratorRequests: false,
    manageMessages: false,
    viewGlobalMonitoring: false,
  },
}
